
export default {
  name: "CardFundingStage",
  props: {
    title: String,
    timestamp: String,
    amount: {
      type: [String, Number],
      default: 0,
    },
    isCurrent: false
  },
  computed: {
    displayDate() {
      if (!this.timestamp) return "-";
      return this.$moment(this.timestamp).format("MMMM DD, YYYY");
    },
    displayAmount() {
      return this.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
